// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__15gIY","subheader":"ReorderModal_subheader__226Ly","listWrap":"ReorderModal_listWrap__OFNxq"};